// Build-time settings (VITE_*), read once. All of them are public by design (WEB_PLAN.md §1.2).

function required(name: string, value: string | undefined): string {
  const v = (value ?? '').trim();
  if (!v) throw new Error(`Missing ${name}. Copy web/.env.example to web/.env.local and fill it in.`);
  return v;
}

function optional(value: string | undefined): string | undefined {
  const v = (value ?? '').trim();
  return v ? v : undefined;
}

const rawUrl = required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL);

export const env = {
  /** The Supabase project URL. `same-origin` (e2e mode) means this page's origin, proxied to the local fake. */
  supabaseUrl: rawUrl === 'same-origin' ? window.location.origin : rawUrl.replace(/\/+$/, ''),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  googleWebClientId: optional(import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID),
  appleServicesId: optional(import.meta.env.VITE_APPLE_SERVICES_ID),
  appleRedirectUri: optional(import.meta.env.VITE_APPLE_REDIRECT_URI),
  /** `download` fetches files through the API instead of signed URLs (the e2e fake has no signing endpoint). */
  filesMode: (import.meta.env.VITE_FILES_MODE === 'download' ? 'download' : 'signed') as 'download' | 'signed',
  /** e2e only: Google/Apple popups are replaced by stubs that mint the fake server's test tokens. */
  authStubs: import.meta.env.VITE_AUTH_STUBS === '1',
  /** Live updates over Realtime (sync/doorbell.ts). `off` keeps polling only (the e2e fake has no Realtime). */
  doorbell: import.meta.env.VITE_DOORBELL !== 'off',
  /** The App Store page, used in invitation messages (same as SyncCenter.appStoreURL). */
  appStoreUrl: 'https://apps.apple.com/app/id6817090143',
  /** Public console URL, used in invitation links. */
  consoleUrl: 'https://groundteam.netlify.app',
} as const;
